<template>
  <div id="topOfApp">
    <v-app-bar app height="80" v-scroll="onScroll">
      <v-toolbar-title class="headline text-uppercase">
        <a v-scroll-to="'#topOfApp'" class="hidden-sm-and-down">
          <span style="color: #009fe3;">SEEJC | SUM</span>
        </a>
        <a v-scroll-to="'#topOfApp'" class="hidden-md-and-up">
          <v-img width="100px" :src="require('@/assets/img/seejc_logo.png')"></v-img>
        </a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon class="hidden-md-and-up" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only">
        <div
            v-for="(item, i) in $t('items')"
            :key="i"
            style="height: 0px; margin-top: 27px; box-shadow: 0px 0px; "
        >
          <a class="nav-act" v-scroll-to="item.link">
            <v-list class="pa-0" style="background-color: transparent">
              <v-list-item class="pl-2 pr-2">
                <v-list-item-title class="body-2">
                  <p style="font-weight: bold; color: #084776" class="text-uppercase" v-html="item.title"></p>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </a>
        </div>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-btn
          text
          color="#009fe3"
          @click="changeLocale('hr')"
      >
        <v-icon small left>mdi-earth</v-icon>
        <span class="mr-2">HRV</span>
      </v-btn>
      <v-btn
          text
          color="#009fe3"
          @click="changeLocale('en')"
      >
        <v-icon small left>mdi-earth</v-icon>
        <span class="mr-2">ENG</span>
      </v-btn>

      <v-navigation-drawer v-model="drawer" absolute temporary app>
        <v-list-item style="height: 78px">
          <v-list-item>
            <img style="width: 100px" :src="require('@/assets/img/seejc_logo.png')"/>
          </v-list-item>

          <!-- <v-list-item-content>
            <v-list-item-title style="color: #084776">Izbornik</v-list-item-title>
          </v-list-item-content> -->
        </v-list-item>

        <v-divider></v-divider>

        <v-list dense>
          <v-list-item v-for="item in $t('items')" :key="item.title" link v-scroll-to="item.link">
            <v-list-item-icon style="width: 25px">
              <v-icon color="#084776">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-list-item-content v-on="on">
                  <v-list-item-title style="color: #084776">{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </v-app-bar>
    <v-img :src="require('@/assets/img/seejc_cover.png')" class></v-img>
    <v-container id="opceInformacije">
      <v-row justify="center">
        <v-col cols="12" md="10" class="text-center">
          <h2 style="color: #009fe3">{{ $t('about') }}</h2>
          <p v-html="$t('about_text')"></p>
        </v-col>

      </v-row>
    </v-container>
    <div>
      <v-img height="500" :src="require('@/assets/img/seejc_vizual.jpg')" class></v-img>
    </div>

    <v-container id="arhiva">
      <v-row align="center" justify="center">
        <v-col cols="12" md="12" class="text-center">
          <h2 style="color: #009fe3">{{ $t('archive') }}</h2>
        </v-col>
        <v-col cols="12" md="3" sm="4" v-for="(post, i) in posts" :key="i">
          <router-link :to="'/arhiva/' + post.alias" style="text-decoration: none">
            <v-img :src="'https://web-admin.sum.ba/api/storage/' + post.image"></v-img>
            <div class="font-weight-bold title text-center">{{ post.title }}</div>
            <div class="subtitle-2 text-center grey--text">{{ post.subtitle }}</div>
          </router-link>
        </v-col>
        <!--        <v-col cols="12" md="4" xs="12" v-for="(item, i) in $t('archive_list')" :key="i">-->
        <!--          <v-card shaped elevation="6">-->
        <!--            <v-card-title></v-card-title>-->
        <!--            <div style="color: #085089" class="mx-4 font-weight-bold title">-->
        <!--              {{ item.title }}-->
        <!--            </div>-->
        <!--            <v-card-subtitle>{{ item.no }}</v-card-subtitle>-->
        <!--            <v-card-actions>-->
        <!--              <v-spacer></v-spacer>-->
        <!--              <v-btn outlined="" class="mr-5" width="100" :href="item.link" target="_blank" color="#084776">-->
        <!--                <v-icon>fas fa-download</v-icon>-->
        <!--              </v-btn>-->
        <!--            </v-card-actions>-->
        <!--          </v-card>-->
        <!--        </v-col>-->
        <v-col id="upute" cols="12" md="12" class="text-center mt-12">
          <h2 style="color: #009fe3">{{ $t('instruction') }}</h2>
        </v-col>
        <v-col cols="12">
          <!--          <div v-html="$t('instruction_text')"></div>-->
          <v-row>
            <v-col cols="12" md="3" v-for="(item, i) in $t('documents')" :key="i">
              <v-row justify="center" align="center">
                <v-col cols="12" class="mb-3 text-center">
                  <div class="mx-5 py-8" style="background-color: #fafafa; border-radius: 8px">
                    <a class="text-decoration-none hover-box" :href="item.link" target="_blank"
                       style="text-decoration: none">
                      <v-icon size="90">mdi-file-pdf-box</v-icon>
                      <div style="font-size: 18px"><b>{{ item.title }}</b></div>
                    </a>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" md="12" class="text-center">
          <h2 style="color: #009fe3">{{ $t('call_for_papers') }}</h2>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-btn outlined="" :href="$t('link')" color="#084776" width="350">{{ $t('download') }}
            <v-icon right>mdi-download</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-container id="urednicko_vijece">
      <v-row align="center" justify="center">
        <v-col cols="12" md="12" class="text-center">
          <h2 style="color: #009fe3">{{ $t('editorial_council') }}</h2>
        </v-col>
        <v-col cols="12" md="3" xs="12" v-for="(item, i) in $t('urednicko_vjece')" :key="i">
          <v-card elevation="6">
            <v-row>
              <v-col cols="12">
                <v-card-title style="color: #085089">{{ item.name }}</v-card-title>
                <v-card-subtitle>{{item.institution}}</v-card-subtitle>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row id="medunarodno_znanstveno" align="center" justify="center">
        <v-col cols="12" md="12" class="text-center">
          <h2 style="color: #009fe3">{{ $t('international_scientific_council') }}</h2>
        </v-col>
        <v-col cols="12" md="4" xs="12" v-for="(item, i) in $t('medunarodno_znanstveno')" :key="i">
          <v-card elevation="6">
            <v-row>
              <v-col cols="12">
                <v-card-title style="color: #085089">{{ item }}</v-card-title>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-col id="urednistvo" cols="12" md="12" class="text-center mt-10">
          <h2 style="color: #009fe3">{{ $t('editorial') }}</h2>
        </v-col>
        <v-col cols="12" md="4" xs="12" class="text-center">
          <v-btn fab color="#009fe3" dark>
            <v-icon>mdi-account</v-icon>
          </v-btn>
          <h3 class="mt-3" style="color: #085089">{{ $t('editor_in') }}</h3>
          <p>Davorka Topić Stipić</p>
          <span class="grey--text">{{ $t('institution') }}</span>
        </v-col>

        <v-col cols="12" md="4" xs="12" class="text-center">
          <v-btn fab color="#009fe3" dark>
            <v-icon>mdi-account-group</v-icon>
          </v-btn>
          <h3 class="mt-3" style="color: #085089">{{ $t('executive') }}</h3>
          <p>Ilija Musa<br>Damir Vasilj<br>Franjo Takač</p>
          <span class="grey--text">{{ $t('institution') }}</span>
        </v-col>
        <v-col cols="12" md="4" xs="12" class="text-center">
          <v-btn fab color="#009fe3" dark>
            <v-icon>mdi-account</v-icon>
          </v-btn>
          <h3 class="mt-3" style="color: #085089">{{ $t('secretary') }}</h3>
          <p>Tonina Ibrulj</p>
          <span class="grey--text">{{ $t('institution') }}</span>
        </v-col>
      </v-row>
    </v-container>
    <div style="background: #e6e4e8" id="kontakt">
      <v-container id="kontakt">
        <v-row align="center" justify="center">
          <v-col cols="12" class="text-center">
            <h2 class="font pb-4" style="color: #085089">{{ $t('contact') }}</h2>
            <p class="font">
              <v-icon class="pr-2" color="#085089" small="">mdi-email</v-icon>
              <span style="color: grey">seejc@sum.ba</span>
            </p>
            <p class="font">
              <v-icon class="pr-2" color="#085089" small="">mdi-map-marker</v-icon>
              <span style="color: grey">Matice hrvatske 1, 88000 Mostar, BiH</span>
            </p>
            <p class="font">
              <v-icon class="pr-2" color="#085089" small="">mdi-web</v-icon>
              <span style="color: grey">
                <a style="color: grey; text-decoration: underline">https://seejc.sum.ba</a>
              </span>
            </p>
          </v-col>
          <!-- <v-col cols="12" sm="6" xs="12">
            <h2 class="font pb-6 text-center" style="color: #085089">Pronađite nas na društvenim mrežama</h2>
            <div class="text-center">
              <v-btn fab color="#3B5998" dark href="#" target="_blank">
                <v-icon>fab fa-facebook-f</v-icon>
              </v-btn>
              <v-btn fab color="#1DA1F2" dark class="ml-3" href="#" target="_blank">
                <v-icon>fab fa-twitter</v-icon>
              </v-btn>
              <v-btn fab color="#FF0000" dark class="ml-3" href="#" target="_blank">
                <v-icon>fab fa-youtube</v-icon>
              </v-btn>
              <v-btn fab color="#F56040" dark class="ml-3" href="#" target="_blank">
                <v-icon>fab fa-instagram</v-icon>
              </v-btn>
              <v-btn fab color="#0077B5" dark class="ml-3" href="#" target="_blank">
                <v-icon>fab fa-linkedin-in</v-icon>
              </v-btn>
            </div>
          </v-col> -->
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import i18n from "./../plugins/i18n"
import axios from 'axios'

export default {
  created() {
    this.getPosts()
    if (localStorage.language_seejc !== 'en') {
      localStorage.setItem("language_seejc", 'hr');
    }
  },
  mounted() {
    if (this.$router.currentRoute['hash']) {
      this.$scrollTo(this.$router.currentRoute['hash'], 500)
    }
  },
  methods: {
    onScroll() {
      this.isScrolling =
          (window.pageYOffset || document.documentElement.scrollTop || 0) > 100;
    },
    changeLocale(locale) {
      this.languageActive = false;
      i18n.locale = locale;
      this.lang = locale.language;
    },
    async getPosts() {
      let requestBody = {
        postsPerPage: 100,
        categories: ["SEEJC Arhiva"],
      };
      axios
          .post("https://web-admin.sum.ba/api/web/objave", requestBody)
          .then(response => {
            this.posts = response.data;
            // console.log(this.news);
          })
      // .catch(error => console.log(error.message));
    },

  },
  data: () => ({
    posts: [],
    languageActive: true,
    lang: 'hr',
    drawer: false,
  })
};
</script>
<style>
/* .red {
    outline: 300px solid rgba(255, 0, 0, 0.5) !important;
    outline-offset: -300px;
    overflow: hidden;
    position: relative;
    height: 200px;
    width: 100%;
} */
</style>

<style scoped>
.hover-box {
  color: #084776 !important;
}

.hover-box:hover i.v-icon.v-icon {
  color: red !important;
}

.hover-box:hover {
  color: red !important;
}
</style>